module.exports = __webpack_public_path__ + "img/point_title2.cdd639ff.svg";